import {styled} from "styled-components";
import type {MouseEvent, RefObject} from "react";
import {ColorUtils} from "../../utils/ColorUtils";
import {baseDistance, FlexCenterStyle, fontSize, fontWeight, radius} from "./styles/styles";
import {ProjectNameDropDownStyled, ProjectNameIconsStyled} from "./topbar/ProjectName.styled";
import ChevronDownIcon from "./icons/chevron-down.svg?react";
import {pseudoLabelTooltipStyle} from "./Root.styled";
import {colorPalette} from "./styles/colorPalette";

type TPortfolioAvatar = {
	readonly name: string;
	readonly thumbnailOnly?: boolean;
	readonly onClick?: (event: MouseEvent) => void;
	readonly onMouseEnter?: (event: MouseEvent) => void;
	readonly onMouseLeave?: (event: MouseEvent) => void;
	readonly divRef?: RefObject<HTMLDivElement>;
	readonly color?: string;
};

export const PortfolioAvatar = (props: TPortfolioAvatar) => {
	const {name, thumbnailOnly, onClick, onMouseEnter, onMouseLeave, divRef, color} = props;
	const initial = name?.includes(" ")
		? name
				.split(" ")
				.map((word) => word.charAt(0).toUpperCase())
				.splice(0, 2)
				.join("")
		: name?.slice(0, 2);

	return (
		<PortfolioAvatarContainer
			$label={thumbnailOnly && name.trim()}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			ref={divRef}
		>
			<ProjectNameDropDownStyled>
				<PortfolioAvatarStyled $color={color}>{initial}</PortfolioAvatarStyled>
				{!thumbnailOnly && (
					<div className="projectNavBar">
						<span
							className="projectNameNavBar"
							title={name}
						>
							{name}
						</span>
						<ProjectNameIconsStyled>
							<ChevronDownIcon />
						</ProjectNameIconsStyled>
					</div>
				)}
			</ProjectNameDropDownStyled>
		</PortfolioAvatarContainer>
	);
};

const PortfolioAvatarStyled = styled.div<{$color: string}>`
	width: 18px;
	height: 16px;
	background-color: ${(props) => (props.$color ? `#${props.$color}` : "black")};
	color: ${(props) => {
		if (!props.$color) {
			return colorPalette.white;
		}
		const hslColor = ColorUtils.hex2hsl(props.$color);
		return hslColor.l >= 0.95 ? "black" : colorPalette.white;
	}};
	font-size: ${fontSize.xs};
	font-weight: ${fontWeight.bold};
	letter-spacing: 0.05px;
	text-align: center;
	line-height: ${baseDistance.md};
	border-radius: ${radius.sm};
	cursor: pointer;
	padding: 0 0px;
`;

const PortfolioAvatarContainer = styled.div<{$label: string}>`
	${FlexCenterStyle}
	gap: ${baseDistance.sm};
	flex: 1;
	position: relative;
	width: 100%;

	${pseudoLabelTooltipStyle}
`;
